var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 68,
    height: 48,
    rx: 13,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 68,
    height: 48,
    rx: 13,
    stroke: "#DCDFE3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9629 19.7161C34.9971 18.7861 35.2587 17.9694 35.7404 17.2869C36.225 16.6007 37.0262 16.1132 38.1225 15.8369L38.1454 15.9382V16.1148C38.1454 16.5152 38.0483 16.9748 37.8566 17.4798C37.6554 17.969 37.3412 18.4298 36.9241 18.8452C36.5341 19.2115 36.1729 19.4536 35.8537 19.5632C35.7487 19.5948 35.6041 19.6257 35.4296 19.6536C35.2746 19.6777 35.119 19.6986 34.9629 19.7161Z",
    fill: "#6A7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1458 21.0958C33.9075 21.0958 33.0475 20 31.8254 20C30.6038 20 28.0867 21.1233 28.0867 25C28.0867 28.8775 30.3221 31.375 30.5721 31.6667C30.8221 31.9587 31.4 32.7083 32.2958 32.7083C33.1917 32.7083 34.1721 31.9963 35.1458 31.9963C36.1196 31.9963 37.3454 32.7087 38.1458 32.7087C38.9458 32.7087 39.275 32.3825 39.8192 31.8196C40.3633 31.2567 41.4025 29.5404 41.765 28.5096C41.1679 28.1538 39.5842 27.1887 39.5842 25.0004C39.5842 23.5418 40.1172 22.33 41.1833 21.365C40.4839 20.4553 39.6728 20.0004 38.75 20.0004C37.3654 20.0004 36.3846 21.0958 35.1458 21.0958Z",
    fill: "#6A7280",
    stroke: "#6A7280",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneIcon);
export default __webpack_public_path__ + "static/media/iphone_icon.35b0d9a598eb387eb9258fd8f952d38c.svg";
export { ForwardRef as ReactComponent };